import { getLocaleCode } from "locales";
import {
  type BreweryTableData,
  type BreweryTableRow,
  type DailyDeliveryResponse,
  Variant,
} from "./types";

export const getVariantColor = (variant?: Variant) => {
  switch (variant) {
    case Variant.Ok:
      return "var(--color-feedback-positive-300)";
    case Variant.FullCapacity:
      return "var(--color-feedback-warning-250)";
    case Variant.Critical:
      return "var(--color-feedback-danger-400)";
    default:
      return "var(--color-neutral-300)";
  }
};

const parseDateLocal = (dateString: string): Date => {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
};

// Função para formatar data com suporte a múltiplos locales
export const formatDate = (dateString: string) => {
  const locale = getLocaleCode();
  return parseDateLocal(dateString).toLocaleDateString(locale);
};

// Função para formatar dia da semana com suporte a múltiplos locales
export const formatWeekday = (dateString: string) => {
  const locale = getLocaleCode();
  return parseDateLocal(dateString).toLocaleDateString(locale, { weekday: "short" }).toUpperCase();
};

// Função para fazer o pivot dos dados por cervejaria
export const pivotByBrewery = (data: DailyDeliveryResponse[]): BreweryTableData => {
  if (!data || data.length === 0) {
    return { columns: ["Brewery"], rows: [] };
  }

  // Extrair datas únicas e ordenar
  const dates = Array.from(new Set(data.map((item) => item.DeliveryDate))).sort((a, b) =>
    a.localeCompare(b)
  );

  // Criar estrutura pivotada agrupando por cervejaria
  const breweryMap = data.reduce<Record<string, BreweryTableRow>>((acc, item) => {
    if (!acc[item.Brewery]) {
      acc[item.Brewery] = {
        Brewery: item.Brewery,
        BreweryId: item.BreweryId,
      };
    }

    // Adicionar dados da data específica
    acc[item.Brewery][item.DeliveryDate] = {
      TotalVolume: item.TotalVolume,
      OrdersCount: item.OrdersCount,
      TotalExpected: item.TotalExpected,
      Capacity: item.Capacity,
      Status: item.Status,
      Family: item.Family,
      FamilyId: item.FamilyId,
    };

    return acc;
  }, {});

  return {
    columns: ["Brewery", ...dates],
    rows: Object.values(breweryMap),
  };
};
